interface EmptyTableRowProps {
  colSpan: number;
  message: string;
}

export default function EmptyTableRow({ colSpan, message }: EmptyTableRowProps) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-12 text-center text-sm text-gray-400">
        {message}
      </td>
    </tr>
  );
}
